"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickForgotPassword = exports.updateForgotPasswordEmail = exports.clickLogin = exports.submitEmail = exports.updatePassword = exports.updateEmail = void 0;

var constants = _interopRequireWildcard(require("./constants"));

var updateEmail = function updateEmail(payload) {
  return {
    type: constants.UPDATE_EMAIL,
    payload: payload
  };
};

exports.updateEmail = updateEmail;

var updatePassword = function updatePassword(payload) {
  return {
    type: constants.UPDATE_PASSWORD,
    payload: payload
  };
};

exports.updatePassword = updatePassword;

var submitEmail = function submitEmail(payload) {
  return {
    type: constants.SUBMIT_EMAIL,
    payload: payload
  };
};

exports.submitEmail = submitEmail;

var clickLogin = function clickLogin(payload) {
  return {
    type: constants.LOGIN_CLICKED,
    payload: payload
  };
};

exports.clickLogin = clickLogin;

var updateForgotPasswordEmail = function updateForgotPasswordEmail(payload) {
  return {
    type: constants.UPDATE_FORGOT_PASSWORD_EMAIL,
    payload: payload
  };
};

exports.updateForgotPasswordEmail = updateForgotPasswordEmail;

var clickForgotPassword = function clickForgotPassword(payload) {
  return {
    type: constants.FORGOT_PASSWORD_CLICKED,
    payload: payload
  };
};

exports.clickForgotPassword = clickForgotPassword;